import { Routes } from '@angular/router';
import { OperateurOrganismesComponent } from './operateur-organismes.component';

export const OPERATEUR_ORGANISMES_ROUTES: Routes = [
    {
        path: '',
        component: OperateurOrganismesComponent,
        data: {
            role: 'INTERVENANT_ORGANISME_LISTE_LECTURE',
            menu: {
                icon: 'address-book',
                libelle: 'menu.operateur-organismes'
            }
        }
    }
];
